/**
 * Public $OBOL mint mirrored from the existing backend token-gate/payment
 * config (GATE_MINT/CASHOUT_OBOL_MINT). Display + decimals-lookup fallback
 * only — every payment still uses the server-stored order mint, and the
 * verifier remains the authority.
 */
// Empty while the token relaunch is pending: contract surfaces render a dash
// and the header copy button is hidden until the new mint is set here.
export const OBOL_CONTRACT_ADDRESS: string = '';
